export default __webpack_public_path__ + "static/media/icon-new-icons.ad66cf31.png";